/* eslint-disable max-len */
const MOTOR_HOME_TYPE = 'motorhome_ext';
const CAR_TYPE = 'auto';
const FIRST_MOTOR_HOME_YEAR = 1997;
const LICENCE_SCOPE_FULL_UK = 'full_uk';
const LICENCE_SCOPE_NO_LICENCE = 'no_licence_held';
const WEB_MOTOR_HOME_MAKE_FIELD = 'MOTOR HOME';
const WEB_MOTOR_HOME_MODEL_FIELD = 'ALL';
const WEB_MOTOR_HOME_DESCRIPTION_FIELD = 'UP TO ';
const WEB_MOTOR_HOME_BODY_TYPE = 'Caravan';
const VEHICLE_LOOKUP_VIEWS = {
    REGISTRATION_LOOKUP: 'registrationLookup',
    MANUAL_LOOKUP: 'manualLookup',
    VEHICLE_SUMMARY: 'vehicleSummary'
};
const BASIC_MOTOR_COVER_NAME = 'Basic Motor Cover';
const ACCIDENT_HEALTHCARE_NAME = 'Accident Healthcare';
const VOLUNTARY_AD_EXCESS_NAME = 'Voluntary AD Excess';
const BASIC_MOTOR_COVER_CODE = 'SPMBasicMotorCover';
const VOLUNTARY_AD_EXCESS_CODE = 'SPMVolExcess';
const COMPULSORY_AD_EXCESS_CODE = 'SPMCompExcess';
const FIRE_THEFT_EXCESS_CODE = 'SPMFireAndTheftExcess';
const ACCIDENT_HEALTH_CARE_CODE = 'SPMAccidentHealthcare';
const PERSONAL_ACCIDENT_CODE = 'SPMIncreasedPersonalAccident';
const REPLACEMENT_CAR_CODE = 'SPMReplacementCarExtension';
const BREAKDOWN_CODE = 'SPMSagaBreakdownAssistance';
const BREAKDOWN_NAME = 'Saga Breakdown Assistance';
const BREAKDOWN_LEVEL_CODE = 'SBALevelOfCover';
const KEY_PROTECTION_CODE = 'SPMKeyProtection';
const NCD_PROTECTION_CODE = 'SPMNCDProtection';
const LEGAL_PROTECTION_CODE = 'SPMLegalProtection';
const SAGA_PLUS_CODE = 'saga_car_insurance';
const NONE = 'None';
const PORTAL_MOTORHOME = 'portal_motorhome';
const UNKNOWN = 'UNKNOWN';

const COVER_LEVEL_TERM_CODE = 'SPMLevelOfCover';

const SBA_TERMS = {
    // car
    ESSENTIAL: 'essential',
    HOME_CALL: 'home_call',
    NATIONAL_RECOVERY: 'national_recovery',
    PREMIER: 'premier',
    COMPREHENSIVE: 'comprehensive',
    // motorhome
    ASSISTANCE: 'assistance',
    ASSISTANCE_PLUS: 'assistance_plus'
};

const VEHICLE_USE = {
    SDP_ONLY: 'sdp_only',
    SDP_COMMUTING: 'sdp_commuting',
    PERSONAL_BUSINESS: 'sdp_business_use_ph_and_partner',
    BUSINESS: 'sdp_business_use_all_drivers'
};

const MAX_DRIVERS_NUMBER = 4;
const ELECTRIC_VEHICLE_ENGINE_SIZE = 0;

const OWNER_TYPE_LEASE_COMPANY = 'lease_company';
const OWNER_TYPE_LEASE_SCHEME_PURCHASE = 'lease_scheme_purchase';
const OWNER_TYPE_OTHER = 'other';
const OWNER_TYPE_PH = 'policyholder';

const MODIFICATION_TYPES = ['alloy_wheels_with_locking_nuts', 'alloys_wheels_no_locking_nuts',
    'hand_controls', 'left_foot_accelerator', 'motor_home', 'larger_capacity_engine', 'lower_suspension',
    'petrol_to_diesel_engine', 'stainless_steel_exhaust', 'steering_wheel_knob'];

const VEHICLE_CODE_AUTO = 'auto';
const VEHICLE_TYPE_MOTORHOME = 'motorhome_ext';
const CAR = 'car';
const TRACKER_TRESHOLD_VALUE = 45000;
const MOTORHOME = 'motorhome';
const MOTOR = 'motor';

const CLAIM_FAULT_CUSTOMER = 'customer';
const CLAIM_FAULT_3RD_PARTY = 'third_party';

const CLAIM_TYPES = {
    ACCIDENT: 'A',
    INCIDENT: 'I',
    THEFT: 'T',
    FIRE: 'F',
    WINDSCREEN: 'W',
    VANDALISM: 'V',
    STORM: 'S'
};

const IMPORTANT_INFORMATION_LINK = 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/motor/saga-car-insurance-important-information.pdf?cd=view';
const SAGA_PLUS_TERMS_LINK = 'https://www.saga.co.uk/insurance/car-insurance/3-year-fixed-price#sagaplustnc';
const FAQ_LINKS = {
    HEALTH_LINK: 'https://www.gov.uk/health-conditions-and-driving',
    MEDICAL_LINK: 'https://www.gov.uk/health-conditions-and-driving',
    COUNTRIES_COVERED_LINK: 'https://www.saga.co.uk/car-insurance/eu-cover#anchor_Whereiscovered ',
    DRIVING_LINK: 'https://www.saga.co.uk/car-insurance/eu-cover'
};
const WHICH_LINK = 'https://www.which.co.uk/money/insurance/car-insurance/car-insurance-reviews/best-and-worst-car-insurance-aqkx76z7t0vw?utm_campaign=recommendedprovider&utm_medium=endorsement&utm_source=Saga';

const POLICY_DOCUMENTS_LINKS = {
    POLICY_BOOKLET_STANDARD: 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/motor/saga-standard-motor-insurance-policy-book.pdf?cd=view',
    POLICY_BOOKLET_SELECT_PLUS: 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/motor/saga-select-and-plus-motor-insurance-policy-book.pdf?cd=view',
    ACCIDENT_HEALTHCARE_BOOKLET: 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/motor/saga-accident-healthcare-policy-book.pdf?cd=view',
    CAR_BREAKDOWN_BOOKLET: 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/motor/saga-breakdown-assistance-policy-book.pdf?cd=view',
    MOTORHOME_BREAKDOWN_BOOKLET: 'https://www.saga.co.uk/helix-contentlibrary/saga/insurance/quote-engines/online-documents/motor/saga-motorhome-breakdown-policy-book.pdf?cd=view'
};

const SBA_COVERAGES = [
    {
        name: 'Essential',
        coverLevel: 'essential',
        UKWideCoverage: true,
        roadsideAssistance: true,
        coverAtHome: false,
        recoveryUK: false,
        europeanCover: false
    },
    {
        name: 'Home Call',
        coverLevel: 'home_call',
        UKWideCoverage: true,
        roadsideAssistance: true,
        coverAtHome: true,
        recoveryUK: false,
        europeanCover: false,
    },
    {
        name: 'National Recovery',
        coverLevel: 'national_recovery',
        UKWideCoverage: true,
        roadsideAssistance: true,
        coverAtHome: false,
        recoveryUK: true,
        europeanCover: false,
    },
    {
        name: 'Comprehensive',
        coverLevel: 'comprehensive',
        UKWideCoverage: true,
        roadsideAssistance: true,
        coverAtHome: true,
        recoveryUK: true,
        europeanCover: false,
    },
    {
        name: 'Premier',
        coverLevel: 'premier',
        UKWideCoverage: true,
        roadsideAssistance: true,
        coverAtHome: true,
        recoveryUK: true,
        europeanCover: true,
    }
];

const MOTORHOME_SBA_COVERAGES = [
    {
        name: 'Assistance',
        coverName: 'Motorhome Assistance',
        coverLevel: 'assistance',
    },
    {
        name: 'Assistance Plus',
        coverName: 'Motorhome Assistance Plus',
        coverLevel: 'assistance_plus',
    },
];

const COVER_LEVEL_CODES = {
    SAGA_STANDARD: 'spm_cover_9',
    SAGA_SELECT: 'fully_comprehensive',
    SAGA_PLUS: 'saga_car_insurance',
    THIRD_PARTY_FIRE_AND_THEFT: 'third_party_fire_and_theft',
    THIRD_PARTY_ONLY: 'third_party_only',
};

const SG_COVER_LEVELS = {
    MOTOR_STANDARD: 'Standard',
    MOTOR_COMPREHENSIVE: 'Select',
    MOTOR_FIXED_PRICE: 'Plus'
};

const IPID_PAGE = {
    Title: 'Title',
    ProductTitle: 'ProductTitle',
    InsuranceTypeDesc: 'InsuranceTypeDesc'
};

const CAR_BREAKDOWN_SERVICES = ['UKWideCoverage', 'roadsideAssistance', 'coverAtHome', 'recoveryUK', 'europeanCover'];
const PHONE_NUMBER_PAGE_STATES = ['vehicle', 'drivers', 'summaryofdrivers', 'blankregistration', 'premium', 'cue', 'declarations', 'aggregatorEntry', 'payment', 'confirmation', 'retrieve'];
const FAQ_QUESTIONS_KEYS = ['otherVehicles', 'european', 'windscreenExcess', 'health', 'tempCover'];

const CAIS_RESPONSE = {
    ERROR: 'Error',
    ERROR_ALLOWED_MONTHLY: 'ErrorAllowedMonthly',
    ERROR_NOT_ALLOWED_MONTHLY: 'ErrorNotAllowedMonthly',
    PASSED_CHECK_SERVICE: 'PassedCheckService',
    PASSED_CHECK_CACHE: 'PassedCheckCache',
    FAILED_CHECK_CACHE: 'FailedCheckCache',
    FAILED_CHECK_SERVICE: 'FailedCheckService'
};

const CTIC_COOKIE_ID = 'ctic';

const PRICE_CHANGE_REASON = {
    CLAIM: 'claim',
    LEASE: 'lease',
    MODIFICATIONS: 'modifications',
    OTHER: 'other'
};

const PNCD_WORDING_THRESHOLD = 5;

const VEHICLE_LOOKUP_STATUS = {
    ERROR: 'lookupError',
    NOT_FOUND: 'notFound',
    SUCCESS: 'Success',
    FAILURE: 'Failure',
    INVALID_REG: 'InvalidReg'
};

const PRE_QUOTE_PAGE_URLS = ['/journey/vehicle', '/journey/drivers', '/journey/summaryofdrivers', '/journey/your-vehicle', 'journey/enhance-your-cover'];

const DEFAULT_CARS_KEPT_AT_HOUSEHOLD_CODE = '1';

export default {
    MOTOR_HOME_TYPE,
    CAR_TYPE,
    FIRST_MOTOR_HOME_YEAR,
    LICENCE_SCOPE_FULL_UK,
    LICENCE_SCOPE_NO_LICENCE,
    WEB_MOTOR_HOME_MODEL_FIELD,
    WEB_MOTOR_HOME_MAKE_FIELD,
    WEB_MOTOR_HOME_DESCRIPTION_FIELD,
    WEB_MOTOR_HOME_BODY_TYPE,
    BASIC_MOTOR_COVER_NAME,
    ACCIDENT_HEALTHCARE_NAME,
    VOLUNTARY_AD_EXCESS_NAME,
    VEHICLE_LOOKUP_VIEWS,
    BASIC_MOTOR_COVER_CODE,
    VOLUNTARY_AD_EXCESS_CODE,
    COMPULSORY_AD_EXCESS_CODE,
    FIRE_THEFT_EXCESS_CODE,
    ACCIDENT_HEALTH_CARE_CODE,
    MAX_DRIVERS_NUMBER,
    ELECTRIC_VEHICLE_ENGINE_SIZE,
    PERSONAL_ACCIDENT_CODE,
    REPLACEMENT_CAR_CODE,
    BREAKDOWN_CODE,
    BREAKDOWN_NAME,
    BREAKDOWN_LEVEL_CODE,
    KEY_PROTECTION_CODE,
    NCD_PROTECTION_CODE,
    LEGAL_PROTECTION_CODE,
    SAGA_PLUS_CODE,
    COVER_LEVEL_TERM_CODE,
    SBA_TERMS,
    VEHICLE_USE,
    IMPORTANT_INFORMATION_LINK,
    CLAIM_FAULT_CUSTOMER,
    CLAIM_FAULT_3RD_PARTY,
    CLAIM_TYPES,
    CAR,
    TRACKER_TRESHOLD_VALUE,
    MOTORHOME,
    MOTOR,
    OWNER_TYPE_LEASE_COMPANY,
    OWNER_TYPE_LEASE_SCHEME_PURCHASE,
    OWNER_TYPE_OTHER,
    OWNER_TYPE_PH,
    MODIFICATION_TYPES,
    VEHICLE_CODE_AUTO,
    VEHICLE_TYPE_MOTORHOME,
    SBA_COVERAGES,
    MOTORHOME_SBA_COVERAGES,
    CAR_BREAKDOWN_SERVICES,
    PHONE_NUMBER_PAGE_STATES,
    FAQ_QUESTIONS_KEYS,
    FAQ_LINKS,
    COVER_LEVEL_CODES,
    IPID_PAGE,
    SG_COVER_LEVELS,
    CAIS_RESPONSE,
    NONE,
    PORTAL_MOTORHOME,
    POLICY_DOCUMENTS_LINKS,
    UNKNOWN,
    SAGA_PLUS_TERMS_LINK,
    CTIC_COOKIE_ID,
    WHICH_LINK,
    PRICE_CHANGE_REASON,
    PNCD_WORDING_THRESHOLD,
    VEHICLE_LOOKUP_STATUS,
    PRE_QUOTE_PAGE_URLS,
    DEFAULT_CARS_KEPT_AT_HOUSEHOLD_CODE
};
